const safeDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatDateDMY = (value) => {
  const d = safeDate(value);
  if (!d) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatTimeHM = (value) => {
  const d = safeDate(value);
  if (!d) return '';
  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');
  return `${hour}:${minute}`;
};

export const formatTimeHMS = (value) => {
  const d = safeDate(value);
  if (!d) return '';
  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');
  const second = String(d.getSeconds()).padStart(2, '0');
  return `${hour}:${minute}:${second}`;
};

export const formatDateTimeDMY = (value) => {
  const date = formatDateDMY(value);
  const time = formatTimeHMS(value);
  if (!date) return '';
  return time ? `${date} ${time}` : date;
};
